import { featureFlagsInitialState } from 'src/constants/constants';

export const SET_FEATURE_FLAGS = 'SET_FEATURE_FLAGS';
export const setFeatureFlags = (featureFlags: any) => ({
  type: SET_FEATURE_FLAGS,
  payload: featureFlags,
});

const initialState: { [key: string]: boolean | undefined } = { ...featureFlagsInitialState };

interface Action {
  type: string;
  payload: any;
}

const featureFlagsReducer = (state = initialState, action: Action) => {
  switch (action.type) {
    case SET_FEATURE_FLAGS:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};
export default featureFlagsReducer;
